import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d5b9f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "trip-container column"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Distancia: ")
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Duración: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.distance)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("strong", null, _toDisplayString(_ctx.distance) + " kms", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("strong", null, _toDisplayString(_ctx.duration) + " minutos", 1)
        ])
      ]))
    : _createCommentVNode("", true)
}